import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const CloseIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox="0 0 14 14" {...props}>
      <path d="M12 4L4 12M4 4L12 12" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSVG>
  )
}
